import { useContext, useMemo } from "react";
import { ControlLayoutContext } from "@plansoft-configuration-renderer/layout";
import { getSubstructureLayoutPropsWithFallback } from "./getSubstructureLayoutPropsWithFallback";
/**
 * Retrieve substructure layout properties from {@link ControlLayoutContext} and provide defaults
 * @returns
 */
export function useSubstructureLayout() {
    const contextProps = useContext(ControlLayoutContext);
    return useMemo(() => getSubstructureLayoutPropsWithFallback(contextProps), [contextProps]);
}
//# sourceMappingURL=useSubstructureLayout.js.map